
    import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
    import type { QuickSlotItem } from "@/cuties/pet/PetService";
    import BlockchainId from "@/cuties/model/pet/BlockchainId";
    import VueUtils from "@/cuties/VueUtils";
    import SelectSendAdventure from "@/components/SelectSendAdventure.vue";
    import CutieCardImagePart from "@/app/components/cutie/cards/CutieCardImagePart.vue";
    import CutieCardTimersList from "@/app/components/cutie/cards/CutieCardTimersList.vue";
    import CutieCardStats from "@/app/components/cutie/cards/CutieCardStats.vue";
    import type { PetModelData } from "@/cuties/model/pet/PetModelData";
    import CutieCardMetaDetailsLine from "@/app/components/cutie/cards/CutieCardMetaDetailsLine.vue";
    import CutieCardWithControls from "@/app/components/cutie/cards/CutieCardWithControls.vue";
    import CutieCardSendToAdventureButton from "@/app/components/cutie/cards/CutieCardSendToAdventureButton.vue";

    /** this component is mostly used on cutie list pages, like Ready for Adventure */
    @Component({
        components: {
            CutieCardSendToAdventureButton,
            CutieCardWithControls,
            CutieCardImagePart,
            SelectSendAdventure,
            CutieCardTimersList,
            CutieCardStats,
            CutieCardMetaDetailsLine,
        },
    })
    export default class ListCutieCard extends Vue {
        @Prop({ required: true }) cutieFromList!: PetModelData;
        @Prop() quickSlotItems: QuickSlotItem[];
        @Prop() showStats: boolean;
        @PropSync("markedWithCheckbox", { default: false }) syncedMarkedWithCheckbox!: boolean;
        @Prop() checkAll: boolean;
        @Prop() uncheckAll: boolean;
        @Prop({ default: false }) controls!: boolean;
        @Prop({ default: false }) disableTooltips!: boolean;
        @Prop({ default: false }) readyForAdventure!: boolean;
        @Prop({ default: false }) emitActionOnCard!: boolean;
        @Prop({ default: "" }) disabledText!: string;

        cutie: PetModelData = null!;

        disabled = false;

        blockchainId: BlockchainId = null!;
        blockchain = "";

        tooltipCloseDelay: number = VueUtils.tooltipCloseDelay;

        healedFromAdventureByItem = false;

        mounted(): void {
            this.cutie = this.cutieFromList;
            this.blockchainId = new BlockchainId(this.cutie.blockchainId);
            this.blockchain = this.blockchainId.blockchain;
        }

        action(): void {
            if (this.emitActionOnCard) {
                if (!this.disabledText) {
                    this.$emit("actionOnCard", this.cutie);
                }
            } else {
                this.$router.push({ path: "/" + this.$i18n.locale + "/pet/" + this.cutie.uid });
            }
        }
    }
